import type {
  DeliveryNoteProofOfDeliveryFacade,
  ProofOfDeliveryDocuments,
  PublicProofOfDeliveryFacade,
} from '../../store';

export interface ProofOfDeliveryFacade {
  saveProofOfDeliveryItem: (params: ProofOfDeliverySaveParams) => void;
  downloadFile: (params: ProofOfDeliveryDownloadFileParams) => void;
}

export interface ProofOfDeliverySaveParams {
  proofOfDeliveryItemValue: ProofOfDeliveryDocuments;
  token: string;
}

export interface ProofOfDeliveryDownloadFileParams {
  documentId: string;
  token: string;
  name: string;
}

export type ProofOfDeliveryFacadeType = PublicProofOfDeliveryFacade | DeliveryNoteProofOfDeliveryFacade;
